//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RepertoryOne from './components/repertoryOne.vue'
import RepertoryTwo from './components/repertoryTwo.vue'
export default {
  components:{
    RepertoryOne,RepertoryTwo
  },
  data() {
    return {
      com:'RepertoryOne',
      shopMsg:{},
    }
  },
  created(){
    this.com = this.$route.query.shopType !== '1'?'RepertoryOne':'RepertoryTwo'
  },
  mounted(){
    this.info()
  },
  methods:{
    info(){
      let data = {
        dealerId:window.sessionStorage.getItem('dealerId'),
        dShopId:this.$route.query.shopId
      }      
      this.shopMsg = []
      this.$axios.post('/mtea/stock/dealer/getShopInfo',data).then(res=>{
        if(this.$route.query.shopType === '0'){
          console.log(window.sessionStorage.getItem('shopMsg'))
          this.shopMsg = JSON.parse(window.sessionStorage.getItem('shopMsg'))
        }else{
          this.shopMsg = res
        }
        this.shopMsg.dStaffName = this.$route.query.dStaffName
      }).catch((err)=>{
        console.log(err)
      })
    },
    comisFun(comIs){
      if(this.com !== comIs){
        this.$refs[this.com].style.backgroundColor = '#d3d1d1'
        this.$refs[comIs].style.backgroundColor = '#f1f1f1'
        this.com = comIs
      }
    },
    alterMsg(){
      this.$router.push({name:'msgAmend',query:{shopId:this.shopMsg.dShopId}})
    },
  }
}
